import React from 'react';
import './ITSoftware.css';

function BFSI() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/bfsi_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>Banking, Financial Services & Insurance</h1>
          <p>Regulatory, tax, and fintech compliance services for the BFSI ecosystem</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>Driving Governance in  Banking, Financial Services, and Insurance  Institutions</h2>
          <p>We provide accounting, GST, and RBI compliance services for NBFCs, fintechs, insurers, and advisors.</p>
          <p>Our services span AML compliance, outsourced CFO, fund flow structuring, and insurance TPA reporting.</p>
          <p>Navigate FEMA rules, digital lending frameworks, and taxation for financial instruments with precision.</p>
          <p>Whether you're a fund house or broker, we enable smooth compliance with SEBI, IRDAI, and RBI mandates.</p>
        </div>
        <div className="content-right">
          <img src="/images/bsfi.jpg" alt="BFSI Industry" />
        </div>
      </section>
    </div>
  );
}

export default BFSI;
